import { render, staticRenderFns } from "./VStatisticPercentChange.vue?vue&type=template&id=73a8781b&"
import script from "./VStatisticPercentChange.vue?vue&type=script&lang=js&"
export * from "./VStatisticPercentChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports